import { useQuery } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { Card, cardSchema } from '../schemas/metabase';
import { QUERY_KEY_CARD } from './useCardData';

export const useGetReportData = (
  id: number | undefined,
  options?: { enabled?: boolean }
) => {
  const {
    data: card,
    isLoading: isCardLoading,
    isError: isCardError,
  } = useQuery<
    Card | undefined,
    unknown,
    Card | undefined,
    (string | number | undefined)[]
  >({
    queryKey: [QUERY_KEY_CARD, id],
    queryFn: async () => {
      if (!id) {
        return undefined;
      }
      const { data } = await metabaseApi.get(`${METABASE_API_URL}/card/${id}`, {
        params: { 'legacy-mbql': true },
      });
      const parsed = cardSchema.safeParse(data);

      if (!parsed.success) {
        // oxlint-disable-next-line no-console
        console.error('Failed to parse card', parsed.error);
        return undefined;
      }

      return parsed.data;
    },
    staleTime: 1000 * 60 * 5,
    ...options,
    enabled: !!id,
  });

  return {
    card,
    isCardLoading,
    isCardError,
  };
};
